export default "__VITE_ASSET__CK0Cp_Yh__"